import React from 'react';
import { Box } from '@tanium/react-box';
import { Link } from '@tanium/react-link';
import { SectionContainerSection } from '@tanium/react-section-container';
import { Stack } from '@tanium/react-stack';
import { useTranslation } from 'react-i18next';
import { LargeText } from '../../TextStyles';
import { DocLinks } from '../../utilities/constants';

export const IdpDocumentationLinks: React.VFC = () => {
  const { t } = useTranslation();

  const links: [name: string, urlPath: string][] = [
    [t('AD FS'), DocLinks.CONFIG_AD_FS],
    [t('Entra ID (Azure AD)'), DocLinks.CONFIG_AZURE],
    [t('Google Cloud'), DocLinks.CONFIG_GOOGLE],
    [t('Okta'), DocLinks.CONFIG_OKTA],
    [t('Oracle'), DocLinks.CONFIG_ORACLE],
    [t('PingFederate'), DocLinks.CONFIG_PING],
    [t('Salesforce'), DocLinks.CONFIG_SF],
  ];

  return (
    <Box mb={-2} mt={-2}>
      <SectionContainerSection title={<LargeText>{t('IDP Documentation')}</LargeText>}>
        <Stack direction="column" itemSpacing={1}>
          {links.map(([name, urlPath]) => (
            <Link target="_blank" href={urlPath} key={name}>
              {name}
            </Link>
          ))}
          <Link target="_blank" href={DocLinks.GETTING_STARTED}>
            {t('Other')}
          </Link>
        </Stack>
      </SectionContainerSection>
    </Box>
  );
};
